export const prefApi = "http://adaptto.lum/api/v2";
